import './Footer.css';

const Footer = () => {
  return (
    <section className='footer container'>
      <a
        href='/'
        aria-current='page'
        className='navbar-logo-wrap w-inline-block w--current'
        id="logo-footer"
      >
        <img
          src='/img/logos/new_type_light.svg'
          className="logo"
          loading='lazy'
          alt='Lancaster Logo'
          width="300"
          height="125"
        />
      </a>
    </section>
  );
};

export default Footer;
